import BannerText from "./BannerText";
import { createBannerText } from "./bannerTextHelper";
import topoTelecom from "../../../assets/images/TOPO_telecom.png";
import topoEnergia from "../../../assets/images/TOPO_energia.png";
import topoSobreNos from "../../../assets/images/empresa/sobre-nos/mapa_brasil_efeito.png";
import topoPessoas from "../../../assets/images/empresa/pessoas/TOPO_pessoas.png";
import topoPoliticas from "../../../assets/images/empresa/docs-politicas/TOPO_politicas_e_lgpd.png";
import topoContato from "../../../assets/images/contato/TOPO_contato.png";

export const bannerTexts: BannerText[] = [
  createBannerText({
    pageName: "home",
    headingItalic: "O mundo",
    headingBold: "TELEMONT",
    descriptionDesktop: `Nós, da TELEMONT, temos plena consciência da nossa responsabilidade e o quanto o que fazemos impacta o seu mundo. 
    Por isso, nosso propósito sempre será oferecer para as pessoas e as organizações o melhor dos serviços de telecomunicação e energia.`,
    descriptionMobile: `Nós, da TELEMONT, temos plena consciência da nossa responsabilidade e o quanto o que fazemos impacta o seu mundo. Por isso, nosso propósito sempre será oferecer para as pessoas e as organizações o melhor dos serviços de telecomunicação e energia.`,
  }),

  createBannerText({
    pageName: "telecom",
    headingItalic: "Uma conexão",
    headingBold: "com o futuro.",
    descriptionDesktop: `Com o uso de tecnologias avançadas e inovação de ponta a<br/>ponta, atuamos em diversas etapas do desenvolvimento do<br/>setor para assegurar a melhor transmissão de dados a<br/>milhões de brasileiros.`,
    descriptionMobile: `Com o uso de tecnologias avançadas e inovação<br/>de ponta a ponta, atuamos em diversas etapas<br/>do desenvolvimento do setor para assegurar<br/>melhor transmissão de dados a milhões<br/>brasileiros.`,
    backgroundImage: topoTelecom,
  }),

  createBannerText({
    pageName: "energia",
    headingItalic: "Distribuindo a energia",
    headingBold: "que nos move",
    descriptionDesktop: `Para atender às variadas demandas energéticas das principais concessionárias de energia do Brasil, a Telemont disponibiliza soluções inovadoras e equipes altamente qualificadas, incluindo a nossa empresa exclusiva para essa área: Personal Energia. Com profissionais especializados e os mais elevados padrões de segurança, a Personal Energia se destaca por sua capacidade de fornecer serviços de excelência, contribuindo para o crescimento e desenvolvimento do setor energético no país.`,
    descriptionMobile: `Para atender às variadas demandas energéticas das principais concessionárias de energia do Brasil, a Telemont disponibiliza soluções inovadoras e equipes altamente qualificadas, incluindo a nossa empresa exclusiva para essa área: Personal Energia. Com profissionais especializados e os mais elevados padrões de segurança, a Personal Energia se destaca por sua capacidade de fornecer serviços de excelência, contribuindo para o crescimento e desenvolvimento do setor energético no país.`,
    backgroundImage: topoEnergia,
  }),

  createBannerText({
    pageName: "sobre-nos-historia",
    headingItalic:
      "Há 51 anos conectando pessoas e realizando serviços essenciais",
    headingBold: "para o desenvolvimento do Brasil.",
    descriptionDesktop: `A Telemont é uma empresa brasileira de grande porte, que se destaca nos segmentos de telecomunicações e energia, realizando serviços de comunicação de voz, banda larga e dados, transporte multimídia e gestão de sistemas de energia.

     Toda essa capacidade de atendimento se traduz em soluções inovadoras, integradas e de qualidade para seus clientes.`,
    descriptionMobile: `A Telemont é uma empresa brasileira de <br/> grande porte, que se destaca nos <br/> segmentos de telecomunicação e energia, <br/> realizando serviços de comunicação de voz, <br/> banda larga e dados, transporte multimídia <br/> e gestão de sistemas de energia. <br/> <br/> Toda essa capacidade de atendimento se <br/> traduz em soluções inovadoras, integradas <br/> e de qualidade para seus clientes.`,
    backgroundImage: topoSobreNos,
  }),

  createBannerText({
    pageName: "sobre-nos-identidade",
    headingItalic: "Uma história que",
    headingBold: "conecta pessoas e soluções.",
    descriptionDesktop: `A excelência em projetos inteligentes é resultado da presença estratégica da Telemont no território nacional, alinhada à qualidade e eficiência dos serviços prestados, aos profissionais engajados que compõem nossos times e à cultura da empresa.`,
    descriptionMobile: `A excelência em projetos inteligentes é resultado da presença estratégica da Telemont no território nacional, alinhada à qualidade e eficiência dos serviços prestados, aos profissionais engajados que compõem nossos times e à cultura da empresa.`,
    backgroundImage: topoSobreNos,
  }),

  createBannerText({
    pageName: "sobre-nos-unidades",
    headingItalic: "Uma história que",
    headingBold: "conecta pessoas e soluções.",
    descriptionDesktop: `A excelência em soluções inovadoras é resultado da presença estratégica da Telemont no território nacional, alinhada à qualidade e eficiência dos serviços prestados, aos profissionais engajados que compõe nossos times e à cultura inovadora da empresa.`,
    descriptionMobile: `A excelência em soluções inovadoras é resultado da presença estratégica da Telemont no território nacional, alinhada à qualidade e eficiência dos serviços prestados, aos profissionais engajados que compõe nossos times e à cultura inovadora da empresa.`,
    backgroundImage: topoSobreNos,
  }),

  createBannerText({
    pageName: "pessoas",
    headingItalic: "Nossa gente,",
    headingBold: "nosso orgulho.",
    descriptionDesktop: `A Telemont é feita de gente. Nosso maior patrimônio está nas <br/> pessoas. Estamos em uma jornada de transformações culturais, <br/> cada vez mais focados em potencializar nossos talentos, além de <br/> impactar positivamente a sociedade e o meio ambiente. <br/> Acreditamos na diversidade como uma forma de integração e <br/> respeito às múltiplas vivências, para a construção de um futuro <br/> mais inclusivo e justo.`,
    descriptionMobile: `A Telemont é feita de gente. Nosso maior <br/> patrimônio está nas pessoas. Por isso, <br/> investimos em segurança e <br/> desenvolvimento para os mais de 12 mil <br/> colaboradores da empresa. Estamos em <br/> uma jornada de transformações culturais, <br/> cada vez mais focados em potencializar <br/> nossos talentos, além de impactar <br/> positivamente a sociedade e o meio <br/> ambiente. Acreditamos na diversidade <br/> como uma forma de integração e respeito <br/> às múltiplas vivências, para a construção de <br/> um futuro mais inclusivo e justo.`,
    backgroundImage: topoPessoas,
  }),

  createBannerText({
    pageName: "midia",
    headingItalic: "O mundo",
    headingBold: "TELEMONT online",
    descriptionDesktop: `Conheça mais sobre a Telemont através das nossas redes sociais.`,
    descriptionMobile: `Conheça mais sobre a Telemont através das nossas redes sociais.`,
  }),

  createBannerText({
    pageName: "docs-politicas",
    headingItalic: "As nossas",
    headingBold: "Políticas",
    descriptionDesktop: `Conheça mais sobre os procedimentos da Telemont.`,
    descriptionMobile: `Conheça mais sobre os procedimentos da Telemont.`,
    backgroundImage: topoPoliticas,
  }),

  createBannerText({
    pageName: "formulario-lgpd",
    headingItalic: "",
    headingBold:
      "Formulário para Requisição do Titular de Dados Pessoais – LGPD",
    descriptionDesktop: ``,
    descriptionMobile: ``,
    backgroundImage: topoPoliticas,
  }),

  createBannerText({
    pageName: "contato",
    headingItalic: "",
    headingBold: "Contatos",
    descriptionDesktop: ``,
    descriptionMobile: ``,
    backgroundImage: topoContato,
  }),
];
